module.exports = __webpack_public_path__ + "img/article9.a17897f5.jpg";